<template>
<div>
    <form @submit.prevent="getCliente" autocomplete="off">
        <md-card>
            <header-form title="LOCALIZAR CLIENTE" :btnHide="true" />
            <md-card-content>
                <div class="md-layout">
                    <div class="md-layout-item md-size-20 md-xsmall-size-100">
                        <md-field :class="{ 'md-error': errors.cpf_cnpj }">
                            <label>CPF OU CNPJ:</label>
                            <md-input v-model="dados.cpf_cnpj" type="text" inputmode="numeric" v-focus autocomplete="off" class="pagamento" v-mask="['###.###.###-##', '##.###.###/####-##']"> </md-input>
                            <slide-y-down-transition>
                                <md-icon class="error" v-show="errors.cpf_cnpj">close</md-icon>
                            </slide-y-down-transition>
                        </md-field>
                        <div v-if="errors.cpf_cnpj" class="validErro"> {{ errors.cpf_cnpj[0] }}</div>
                    </div>

                    <div class="md-layout-item md-size-15 md-xsmall-size-100">
                        <md-button type="submit" class="md-site md-round md-block">
                            <span class="md-label">
                                <md-icon class="material-icons">search</md-icon>
                            </span>BUSCAR
                        </md-button>
                    </div>
                </div>
                <div v-if="message" class="alert alert-danger" style="padding: 1px 15px">
                    <h4> {{message}} </h4>
                </div>
            </md-card-content>
        </md-card>
    </form>
</div>
</template>

<script>    
import Notify from '@/config/mixins/notify'
import HeaderForm from '@/pages/Layout/Extra/HeaderForm'
import preLoader from '@/config/mixins/preLoader';

export default {
    components: {
        HeaderForm
    },
    data() {
        return {
            dados: {
                parcelas: 1
            },
            parcelas: [],
            message: null,
            errors: {}
        }
    },
    mixins: [Notify, preLoader],

    created () {
        this.authorize();
    },

    methods: {
        authorize() {
            this.$http.get(this.$urlAPI + 'autorizado')
                .then(response => {

                })
                .catch(e => {
                    this.msgErrors(e)
                })
        },

        getCliente() {
            let loader = this.openLoader('dots');
            this.$http.post(this.$urlAPI + 'pagamentos/buscar', this.dados)
                .then(response => {
                    if (response.data.status) {
                        this.errors = ''
                        this.message = null
                        this.$router.push({ name: 'pagamentosStore', params: { id: response.data.dados[0].id } });
                    } else if (response.data.errors) {
                        this.errors = response.data.errors
                    } else {
                        this.message = response.data.message;
                        this.errors = ''
                    }
                })
                .catch(e => {
                    this.msgErrors(e)
                })
                .finally(function () {
                    loader.hide();
                });
        }
    }
};
</script>

<style>
.text-label {
    margin-top: -25px !important;
}

.md-toggle-password,
.error {
    visibility: hidden !important;
}
</style>
